import React, { useEffect, useState } from "react";
import { Folder } from "../../api/types";
import { apiFetch } from "../../api/client";
import { AuthExpiredError } from "../../api/auth";

interface Props {
  selectedFolderId: string | null;
  onSelect: (id: string | null) => void;
  onAuthExpired: () => void;
}

export default function FolderList({ selectedFolderId, onSelect, onAuthExpired }: Props) {
  const [folders, setFolders] = useState<Folder[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiFetch<Folder[]>("/folder")
      .then((data) => {
        const sorted = [...data].sort((a, b) => a.order_index - b.order_index);
        setFolders(sorted);
      })
      .catch((err) => {
        if (err instanceof AuthExpiredError) {
          onAuthExpired();
        } else {
          setError("Failed to load folders.");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="folder-list loading-text">Loading…</div>;
  if (error) return <div className="folder-list folder-error">{error}</div>;

  return (
    <div className="folder-list">
      <div
        className={`folder-item${selectedFolderId === null ? " selected" : ""}`}
        onClick={() => onSelect(null)}
      >
        All Plays
      </div>
      {folders.map((f) => (
        <div
          key={f._id}
          className={`folder-item${selectedFolderId === f._id ? " selected" : ""}`}
          onClick={() => onSelect(f._id)}
        >
          {f.name}
        </div>
      ))}
    </div>
  );
}
